export default "__VITE_ASSET__Dpf5gjpS__"